import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/img/logo.png'
import _imports_1 from '@/img/defaultprofile.jpg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "sideMenuImage" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_2 = { class: "text-center mt-4" }
const _hoisted_3 = { class: "text-center px-4 my-2" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "navContainer" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "opener" }
const _hoisted_8 = {
  key: 0,
  class: "fa fa-chevron-up"
}
const _hoisted_9 = {
  key: 1,
  class: "fa fa-chevron-down"
}
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "sideNavModule logout" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-sign-out" }, null, -1)
const _hoisted_13 = { class: "sideNavBottom" }
const _hoisted_14 = { class: "avatarRound" }
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  src: _imports_1,
  key: "def"
}
const _hoisted_17 = { class: "loginName" }
const _hoisted_18 = { class: "name" }
const _hoisted_19 = { class: "role" }
const _hoisted_20 = { class: "container-fluid mainContainer" }
const _hoisted_21 = {
  key: 0,
  class: "header"
}
const _hoisted_22 = {
  key: 0,
  class: "upperSlug"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times" }, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-wrench fa-2x",
  style: {"color":"rgb(127, 214, 220)"}
}, null, -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = { class: "routerView" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_select = _resolveComponent("op-select")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_notifications = _resolveComponent("notifications")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("nav", {
      class: _normalizeClass(["sideMenu", {'open': _ctx.openSideMenu}])
    }, [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.linkedAccountModal && _ctx.linkedAccountModal(...args)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Account collegati",
            text: "Account collegati"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_op_select, {
          options: _ctx.$store.state.consts.enabledLanguages,
          modelValue: _ctx.$store.state.user.preferredCulture,
          "onUpdate:modelValue": [
            _cache[1] || (_cache[1] = ($event: any) => ((_ctx.$store.state.user.preferredCulture) = $event)),
            _ctx.setLanguage
          ]
        }, {
          default: _withCtx((option) => [
            _createElementVNode("div", null, [
              _createElementVNode("img", {
                class: "mr-2",
                src: require('@/img/langs/' + option.item + '.svg')
              }, null, 8, _hoisted_4),
              _createTextVNode(" " + _toDisplayString(option.item.substring(0, 2)), 1)
            ])
          ]),
          _: 1
        }, 8, ["options", "modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderedModules, (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (item.values && item.values.length > 1)
              ? (_openBlock(), _createElementBlock("div", {
                  class: "sideNavGroupLabel",
                  key: index
                }, _toDisplayString(item.text), 1))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.values, (value) => {
              return (_openBlock(), _createElementBlock("div", {
                key: value.label,
                class: "sideNavModule"
              }, [
                (value.children.length == 0)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: value.routeName,
                      class: "sideNav"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("i", {
                          class: _normalizeClass(value.icon)
                        }, null, 2),
                        _createElementVNode("span", null, [
                          _createVNode(_component_localized_text, {
                            localizedKey: value.label,
                            text: value.label
                          }, null, 8, ["localizedKey", "text"])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(["sideNav withChildren", { open: (value as any).open }]),
                      onClick: ($event: any) => (_ctx.open(value))
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(value.icon)
                      }, null, 2),
                      _createElementVNode("span", null, [
                        _createVNode(_component_localized_text, {
                          localizedKey: value.label,
                          text: value.label
                        }, null, 8, ["localizedKey", "text"])
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        ((value as any).open)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_8))
                          : (_openBlock(), _createElementBlock("i", _hoisted_9))
                      ])
                    ], 10, _hoisted_6)),
                (value.children.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterChildren(value.children), (child, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: i,
                          class: "sideNav child"
                        }, [
                          _createVNode(_component_router_link, {
                            to: child.routeName,
                            class: "sideNav"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("i", {
                                class: _normalizeClass(child.icon)
                              }, null, 2),
                              _createElementVNode("span", null, [
                                _createVNode(_component_localized_text, {
                                  localizedKey: child.label,
                                  text: child.label
                                }, null, 8, ["localizedKey", "text"])
                              ])
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ], 64))
        }), 256)),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("a", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.logout())),
            class: "sideNav pointer"
          }, [
            _hoisted_12,
            _createElementVNode("span", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Logout",
                text: "Logout"
              })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          (_ctx.$store.state.user.personalData.profilePicture)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.$store.state.user.personalData.profilePicture
              }, null, 8, _hoisted_15))
            : (_openBlock(), _createElementBlock("img", _hoisted_16))
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$store.state.user.personalData.completeName), 1),
          _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$store.state.user.role), 1)
        ])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_20, [
      (_ctx.$store.state.layoutSlugs.length > 0 || _ctx.$store.state.layoutSlugButtonAdd)
        ? (_openBlock(), _createElementBlock("header", _hoisted_21, [
            _createElementVNode("div", {
              class: _normalizeClass(["slugsContainer", { show: _ctx.showSlugs }])
            }, [
              (_ctx.$store.state.layoutSlugButtonAdd)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-shadow fs-22",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.$store.state.layoutSlugButtonAdd.callback && _ctx.$store.state.layoutSlugButtonAdd.callback(...args)))
                    }, _toDisplayString(_ctx.$store.state.layoutSlugButtonAdd.text), 1)
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.layoutSlugs, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["upperSlug pointer", { 'selected': item.selected }]),
                  key: i,
                  onClick: ($event: any) => (_ctx.slugCb(item))
                }, [
                  _createElementVNode("div", null, [
                    (item.text == 'whatsapp')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Prenotazione evento",
                            text: "Prenotazione evento"
                          })
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(item.text), 1))
                  ]),
                  (item.removeCallback)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "removeSlug",
                        onClick: _withModifiers(($event: any) => (item.removeCallback(item)), ["stop","prevent"])
                      }, _hoisted_28, 8, _hoisted_26))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_23))
              }), 128))
            ], 2),
            _createVNode(_component_notifications),
            (_ctx.$store.state.layoutSlugButtonAdd || _ctx.$store.state.layoutSlugs.length > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "slugOpener",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showSlugs = !_ctx.showSlugs))
                }, _hoisted_30))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_31, [
        (_openBlock(), _createBlock(_component_router_view, {
          key: _ctx.routeBuster,
          class: "box"
        }))
      ])
    ])
  ]))
}